import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import store from "./ReduxStore/Store"
import { Provider } from 'react-redux'
ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
    <App />
    {/* </React.StrictMode> */}
  </Provider>
)